import { useTheme } from "@/design-system/theme/useTheme";
import { NavbarActionToggleProps } from "./types";

/**
 * Navbar 操作按鈕組件
 * 提供統一風格的導航欄操作按鈕
 */
export function NavbarActionToggle({
  onClick,
  children,
  title,
  ariaLabel,
  className = "",
  isActive = false,
}: NavbarActionToggleProps) {
  const { isDarkMode } = useTheme();

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex items-center justify-center rounded-full p-2 transition-all 
        hover:bg-opacity-80 z-10 relative w-8 h-8 cursor-pointer
        ${isActive ? (isDarkMode ? "shadow-sm" : "shadow-sm") : ""}
        ${
          isActive
            ? isDarkMode
              ? "bg-primary-700 text-primary-300"
              : "bg-primary-100 text-primary-600"
            : isDarkMode
              ? "bg-gray-800/40 text-gray-300"
              : "bg-gray-200/80 text-gray-700"
        }
        ${className}
      `}
      aria-label={ariaLabel}
      title={title}
    >
      {children}
    </button>
  );
}
